export default {"src":"/bnb/_next/static/media/bnbx-light.d7fbd240.svg","height":28,"width":28};